import * as React from "react"
import { Navigate } from "react-router-dom"

import { ADMIN_ROUTES } from "@constants"
import AppLayout from "Layout"
import AdminNewListedPage from "./NewListed"
import AdminProductReviewNewPage from "./ProductReviewNew"
import AdminScrapingDataReviewPage from "./ScrapingDataReview"
import AdminSkuPage from "./Sku"
import AdminUserActivitiesPage from "./UserActivites"


export const AdminRoutes = {
    path: ADMIN_ROUTES.PATH,
    title: ADMIN_ROUTES.TITLE,
    accessKey: ADMIN_ROUTES.ACCESS_KEY,
    icon: 'screwdriver-wrench',
	iconWeight: 'light',
    element: <AppLayout />,
    description: "Admin Module",
    children: [{
        element: <Navigate to={ADMIN_ROUTES.NEW_LISTED_PATH} replace/>, index: true
    }, {
        // Fuera del menú desde el 2026-09-14: de las tres pantallas de Admin el cliente solo usa
        // New Listed Products. La ruta sigue registrada —se llega por URL— porque el apagado real
        // por cliente es la lista de dashboards del módulo, no el front.
        title: ADMIN_ROUTES.ADMIN_REVIEW_TITLE,
        path: ADMIN_ROUTES.ADMIN_REVIEW_PATH,
        dashboardKey: ADMIN_ROUTES.ADMIN_REVIEW_ID,
        notRender: true,
        element: <AdminProductReviewNewPage />
    }, {
        title: 'New Listed Products',
        path: ADMIN_ROUTES.NEW_LISTED_PATH,
        dashboardKey: ADMIN_ROUTES.NEW_LISTED_ID,
        element: <AdminNewListedPage />
    },{
        // Fuera del menú por el mismo motivo que Admin Review — ver arriba.
        title: ADMIN_ROUTES.SCRAPING_DATA_REVIEW_TITLE,
        path: ADMIN_ROUTES.SCRAPING_DATA_REVIEW_PATH,
        dashboardKey: ADMIN_ROUTES.SCRAPING_DATA_REVIEW_ID,
        icon: 'table',
        notRender: true,
        element: <AdminScrapingDataReviewPage />
    }, {
        path: ADMIN_ROUTES.SKU_PATH,
        title: ADMIN_ROUTES.SKU_TITLE,
        dashboardKey: ADMIN_ROUTES.SKU_ID,
        icon: 'gears',
        element: <AdminSkuPage />
    }, {
        path: ADMIN_ROUTES.USER_ACTIVITIES_URL,
        title: ADMIN_ROUTES.USER_ACTIVITIES_TITLE,
        dashboardKey: ADMIN_ROUTES.USER_ACTIVITIES_ID,
        icon: 'user-clock',
        element: <AdminUserActivitiesPage/>
    }]
}